import React, {Component} from "react";
import FJVideoTool from "../../modal/view/stockVideo/video/FJVideoTool";
import Style from './FJExportPreview.module.less'
import FJPureLoading from "../../../common/component/FJLoading/FJPureLoading";
import FJRetry from "./FJRetry.react";
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import FJUtil from "../../../util/FJUtil";
import key from 'keymaster'

class FJExportPreview extends Component {

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.width !== prevProps.width || this.props.height !== prevProps.height) {
      this.props.onUpdateCanvasSize(this.props.width, this.props.height);
    }
  }

  _onBeforeChange = (value, progress) => {
    this.props.onSeek('start', progress);
    key.setScope('');
  };

  _onChange = (value, progress) => {
    this.props.onSeek('change', progress);
  };

  _onAfterChange = (value, progress) => {
    this.props.onSeek('end', progress);
    key.setScope('exportPreview');
  };

  _renderLoading = () => {
    return (
      <div className={Style.loading_box}>
        <FJPureLoading style={{transform: 'scale(0.34)'}}/>
      </div>
    );
  };

  _renderRetry = () => {
    const {onRetry, retryDesc, retryText} = this.props;
    return (
      <div className={Style.retry_box}>
        <FJRetry desc={retryDesc}
                 retryText={retryText}
                 retryCallback={onRetry}
        />
      </div>
    );
  };

  _handlePlay = () => {
    this.props.onPlay();
  };

  _renderController = () => {
    const {isPlaying, currentTime, duration} = this.props;
    const {onVolumeChange, volume} = this.props;
    const progress = FJCoreUtil.toFixed(currentTime / duration, 6);
    return (
      <FJVideoTool isPlaying={isPlaying}
                   play={this._handlePlay}
                   onBeforeChange={this._onBeforeChange}
                   onChange={this._onChange}
                   onAfterChange={this._onAfterChange}
                   progress={progress}
                   currentTime={FJUtil.formatTime(currentTime)}
                   totalTime={FJUtil.formatTime(duration)}
                   setVideoVolume={onVolumeChange}
                   isLoaded
                   volume={volume}
      />
    );
  };

  getView = () => {
    return this._view;
  };

  _onViewHandleClick = () => {
    const {introStatus} = this.props;
    const {onPlay} = this.props;
    if (introStatus === 'success') {
      onPlay();
    }
  };

  render() {
    const {width, height, previewWidth, previewHeight, introStatus,} = this.props;
    const previewStyle = {width: `${previewWidth}px`, height: `${previewHeight}px`};
    return (
      <div className={Style.box}
           style={{width: `${width}px`, height: `${height}px`}}>
        <div className={Style.content}
             onClick={this._onViewHandleClick}
             style={previewStyle}>
          <canvas style={previewStyle}
                  width={previewWidth}
                  height={previewHeight}
                  ref={ele => {this._view = ele}}/>
          {introStatus === 'loading' && this._renderLoading()}
          {introStatus === 'error' && this._renderRetry()}
        </div>
        {introStatus === 'success' || introStatus === 'loading' ? this._renderController() : null}
      </div>
    );
  }
}

export default FJExportPreview;
